// extracted by mini-css-extract-plugin
module.exports = {"contactLabel":"how-it-works-details-page_contactLabel__eoOWb"};